import StatusPage from "../../components/status/status-page";
import Page from "../page";

const Status = () => {
  return (
    <Page>
      <StatusPage />
    </Page>
  );
};

export default Status;
